import { gql } from 'graphql-request'

export const SALE_CHANNELS = gql`
  query SaleChannels {
    saleChannels {
      name
    }
  }
`
